module.exports = __webpack_public_path__ + "static/theCabinCapital-baf431526067da774dc9c4aba0068fbf.png";